import { Injectable } from '@angular/core';
import { WindowRef } from './window-ref.service';
/// <reference path="../../types/global.d.ts" />
declare let ga:any; 
declare let gtag:any; 
@Injectable({
  providedIn: 'root'
})

export class GoogleAnaylticsService {
  constructor(private _windowRef: WindowRef) { }

   
   public sendPageTrackingLog(arData: any) {
    let arPageTracing = {
        eventCategory: arData.eventCategory || '',
        userLogin: arData.user_login || '',
        userCharterer: arData.user_charterer || '',
        userEmail: arData.user_email || '',
        userName: arData.user_name || '',
        eventAction:arData.eventAction || '',
        eventLabel:arData.eventLabel || '',
        eventValue:arData.eventValue || ''
    };
    this.addGoogleTagsLog(arPageTracing);
}

    public addGoogleTagsLog(arData: any) {
        if (arData.eventCategory) {
            let arDataLayer = arData;
            arDataLayer.event = arData.eventCategory;
            this._windowRef.nativeWindow.dataLayer?.push(arDataLayer);
        }
    }
    public triggerGTMEvent(eventName: string, data?: any) {
        window.dataLayer = window.dataLayer || [];

        // Create a new object to hold the combined event and data
        const eventObject = { 'event': eventName };

        // Iterate over the properties of the data object and add them
        for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
            eventObject[key] = data[key];
            }
        }

        // Push the combined object to the data layer
        window.dataLayer.push(eventObject);
    }
}





